import React, {Component} from 'react';
import { Trans, t } from '@lingui/macro';
import {connect} from 'react-redux';
import {Popover} from 'antd';
import dayjs from 'dayjs';
import TransactionActions from 'bukku/redux/Transaction/actions';
import { IconFont } from '../IconFont';
import { SubscriptionCheck } from '../Access/helper/subscription/SubscriptionCheck';
import { SubscriptionScopeKey } from '../Access/helper/subscription/enum/SubscriptionScopeKey';
import { LockTooltip } from '../Access/common/LockTooltip';

const { openEmailTracker } = TransactionActions;

class TransactionEmailStatus extends Component {
    constructor(props) {
        super(props);
        this.isLocked = props.isContact
            ? !SubscriptionCheck
                .withKeys(SubscriptionScopeKey['CONTACT.STATEMENT.E_STATEMENT.EMAIL_TRACKER'])
                .hasSubscriptionTo()
            : !SubscriptionCheck
                .withKeys(SubscriptionScopeKey['TRANSACTION.QUICKSHARE.EMAIL_TRACKER'])
                .hasSubscriptionTo();
    }

    onClick = () => {
        const { openEmailTracker, record, isContact } = this.props;
        if (!isContact)
            openEmailTracker(record.type, record.id);
        else
            openEmailTracker('contacts', record.id);
    };

    renderPopoverTitle = () => {
        const {
            record,
        } = this.props;

        switch (record.email_status) {
            case 'PENDING':
                return <Trans>Pending Send</Trans>;
            case 'SENT':
                return <Trans>Sent</Trans>;
            case 'BOUNCED':
                return <Trans>Bounced / Failed</Trans>;
            case 'OPENED':
                return <Trans>Email Opened</Trans>;
            case 'VIEWED':
                return <Trans>Transaction Viewed</Trans>;
            case 'NOT_SENT': default:
                return <Trans>Not Sent</Trans>;
        }
    };

    renderPopoverContent = () => {
        const {
            record,
        } = this.props;

        let datetime;
        switch (record.email_status) {
            case 'PENDING':
                datetime = dayjs(record.email_updated_at).format("DD/MM/YYYY h:mma");
                return (
                    <Trans>
                        Created on&nbsp;
                        {datetime}
                    </Trans>
                );
            case 'SENT':
                datetime = dayjs(record.email_updated_at).format("DD/MM/YYYY h:mma");
                return (
                    <Trans>
                        Sent on&nbsp;
                        {datetime}
                    </Trans>
                );
            case 'BOUNCED':
                datetime = dayjs(record.email_updated_at).format("DD/MM/YYYY h:mma");
                return (
                    <span>
                        <Trans>
                            Bounced on&nbsp;
                            {datetime}
                        </Trans>
                        <br />
                        <Trans>Reason: </Trans>
                        {record.email_note || 'N/A'}
                    </span>
                );
            case 'OPENED':
                datetime = dayjs(record.email_updated_at).format("DD/MM/YYYY h:mma");
                return (
                    <Trans>
                        Opened on&nbsp;
                        {datetime}
                    </Trans>
                );
            case 'VIEWED':
                datetime = dayjs(record.email_updated_at).format("DD/MM/YYYY h:mma");
                return (
                    <Trans>
                        Viewed on&nbsp;
                        {datetime}
                    </Trans>
                );
            case 'NOT_SENT': default:
                return <Trans>No Data</Trans>;
        }
    };

    renderIcon = () => {
        const {
            record,
        } = this.props;

        switch (record.email_status) {
            case 'PENDING':
                return <IconFont type="icon-email-pending" />;
            case 'SENT':
                return <IconFont type="icon-email-sent" />;
            case 'BOUNCED':
                return <IconFont type="icon-email-bounced" />;
            case 'OPENED':
                return <IconFont type="icon-email-opened" />;
            case 'VIEWED':
                return <IconFont type="icon-email-viewed" />;
            case 'NOT_SENT': default:
                return <IconFont type="icon-email-unsent" />;
        }
    };

    render() {
        // If locked, render icon only
        if (this.isLocked) {
            return (
                <LockTooltip title={t`Email tracker is not available in your subscription plan.`}>
                    <span
                        style={{
                            fontSize: 20,
                            cursor: 'default',
                        }}
                        onClick={e => {
                            e.stopPropagation();
                        }}
                    >
                        {this.renderIcon()}
                    </span>
                </LockTooltip>
            );
        }

        return (
            <Popover title={this.renderPopoverTitle()} content={this.renderPopoverContent()}>
                <span
                    style={{
                        fontSize: 20,
                        cursor: !this.isLocked ? 'pointer' : null,
                    }}
                    onClick={e => {
                        if (!this.isLocked) {
                            this.onClick();
                            e.stopPropagation();
                        }
                    }}
                >
                    {this.renderIcon()}
                </span>
            </Popover>
        );
    }
}
export default connect(() => ({
    //
}), {
    openEmailTracker,
})(TransactionEmailStatus);
